var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesAirPurifierFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 8a1 1 0 11-2 0 1 1 0 012 0zM18 15h2v2h-2v-2zM18 19h2v2h-2v-2zM18 23h2v2h-2v-2zM15 15h2v2h-2v-2zM15 19h2v2h-2v-2zM15 23h2v2h-2v-2zM12 15h2v2h-2v-2zM12 19h2v2h-2v-2zM12 23h2v2h-2v-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 15h5v2H2v-2zM2 19h5v2H2v-2zM2 23h5v2H2v-2zM22 5H10v23h12V5zM10 3a2 2 0 00-2 2v25h16V5a2 2 0 00-2-2H10z",
    fill: props.color
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 14h4v14h-4V14z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.585 17.748C22.048 17.27 21.73 17 21 17v-2c1.504 0 2.309.715 2.896 1.236l.018.016c.536.477.856.748 1.588.748.732 0 1.051-.27 1.586-.747l.018-.016C27.692 15.716 28.496 15 30 15v2c-.729 0-1.046.27-1.582.747l-.016.014c-.587.523-1.391 1.239-2.9 1.239-1.507 0-2.313-.716-2.901-1.238l-.016-.014zM22.585 21.748C22.048 21.27 21.73 21 21 21v-2c1.504 0 2.309.715 2.896 1.236l.018.016c.536.477.856.748 1.588.748.732 0 1.051-.27 1.586-.747l.018-.016C27.692 19.716 28.496 19 30 19v2c-.729 0-1.046.27-1.582.747l-.016.014c-.587.523-1.391 1.239-2.9 1.239-1.507 0-2.313-.716-2.901-1.238l-.016-.014zM22.585 25.748C22.048 25.27 21.73 25 21 25v-2c1.504 0 2.309.715 2.896 1.236l.018.016c.536.477.856.748 1.588.748.732 0 1.051-.27 1.586-.747l.018-.016C27.692 23.716 28.496 23 30 23v2c-.729 0-1.046.27-1.582.747l-.016.014c-.587.523-1.391 1.239-2.9 1.239-1.507 0-2.313-.716-2.901-1.238l-.016-.014z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesAirPurifierFilled;